import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=23284638&scoped=true"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23284638",
  null
  
)

export default component.exports